import UIHelper from '../../../../../helpers/UIHelper';

export const invoiceAdapter = (data) => {
  if (!data) {
    return [];
  }

  const newArr = [];

  const prepareData = (i) => ({
    ...i,
    'shopping_centers.title': i?.company?.shopping_center?.title,
    'shop_name': i?.company?.name,
    taxable_vat: UIHelper.removeDot(i.taxable_vat),
    taxable: UIHelper.removeDot(i.taxable),
    conversion_rate: UIHelper.removeDot(i.conversion_rate),
    upt: UIHelper.removeDot(i.upt),
    atv: UIHelper.removeDot(i.atv),
  });

  if (Array.isArray(data)) {
    data.forEach((i) => {
      newArr.push(prepareData(i));
    });

    return newArr;
  }

  return prepareData(data);
};
